import { render } from "./ArtiveFooter.vue?vue&type=template&id=7a3bd45c&scoped=true"
import script from "./ArtiveFooter.vue?vue&type=script&lang=js"
export * from "./ArtiveFooter.vue?vue&type=script&lang=js"

import "./ArtiveFooter.vue?vue&type=style&index=0&id=7a3bd45c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3bd45c"]])

export default __exports__